import { omit } from "lodash";
import { ImportConfigAction, ImportConfigActions } from "../actions";
import { mapGroupsState, mapStepsState } from "../services";
import { ImportConfigState } from "../state";

export const importConfigInitialState: ImportConfigState = Object.freeze({
  dirty: false,
  editStepPanelOpen: false,
  editingStep: null,
  id: null,
  isLoading: true,
  providerNetworkId: null,
  settings: {
    autoActivate: false,
    autoComplete: false,
    autoRun: false,
  },
  versionId: null,
});

export const importConfigReducer = (state: ImportConfigState, action: ImportConfigActions): ImportConfigState => {
  switch (action.type) {
    case ImportConfigAction.AddGroupsSuccess:
      return Object.freeze({
        ...state,
        groups: {
          ...state.groups,
          ...mapGroupsState(action.response),
        },
        steps: {
          ...state.steps,
          ...mapStepsState(action.response),
        },
      });
    case ImportConfigAction.EditStepHide:
      return Object.freeze({
        ...state,
        editStepPanelOpen: false,
        editingStep: null,
      });
    case ImportConfigAction.EditStepShow:
      return Object.freeze({
        ...state,
        editStepPanelOpen: true,
        editingStep: action.step,
      });
    case ImportConfigAction.LoadConfiguration:
      return Object.freeze({
        ...state,
        isLoading: true,
        providerNetworkId: action.networkId,
        versionId: action.versionId,
      });
    case ImportConfigAction.LoadConfigurationSuccess:
      return Object.freeze({
        ...state,
        groups: mapGroupsState(action.result.groups),
        id: action.result.id,
        isLoading: false,
        settings: { autoActivate: action.result.autoActivate, autoComplete: action.result.autoComplete, autoRun: action.result.autoRun },
        steps: mapStepsState(action.result.groups),
      });
    case ImportConfigAction.LoadConfigurationFailure:
      return Object.freeze({
        ...state,
        isLoading: false,
      });
    case ImportConfigAction.RemoveGroupSuccess:
      const steps = omit(state.steps, state.groups[action.group].transformSteps, state.groups[action.group].appendSteps, state.groups[action.group].filterSteps, state.groups[action.group].validateSteps, state.groups[action.group].querySteps);
      const groups = omit(state.groups, action.group);
      return Object.freeze({
        ...state,
        groups,
        steps,
      });
    case ImportConfigAction.ToggleAutoActivate:
      return Object.freeze({
        ...state,
        settings: {
          ...state.settings,
          autoActivate: !state.settings.autoActivate,
        },
      });
    case ImportConfigAction.ToggleAutoComplete:
      return Object.freeze({
        ...state,
        settings: {
          ...state.settings,
          autoComplete: !state.settings.autoComplete,
        },
      });
    case ImportConfigAction.ToggleAutoRun:
      return Object.freeze({
        ...state,
        settings: {
          ...state.settings,
          autoRun: !state.settings.autoRun,
        },
      });
    case ImportConfigAction.ToggleStep:
      return Object.freeze({
        ...state,
        steps: {
          ...state.steps,
          [action.step]: {
            ...state.steps[action.step],
            enabled: !state.steps[action.step].enabled,
          },
        },
      });
    case ImportConfigAction.SetStepEdited:
      return Object.freeze({
        ...state,
        steps: {
          ...state.steps,
          [action.step]: {
            ...state.steps[action.step],
            dirty: true,
          },
        },
      });
    default:
      throw new Error(`Action ${JSON.stringify(action)} not handled in importConfigReducer`);
  }
};
